<script setup>
import { computed, ref, useAttrs } from 'vue'

// קבלת כל הפרופסים + attrs
const props = defineProps({
  modelValue: [String, Number, Object, null],
  options: { type: Array, required: true },
  optionLabel: { type: String, default: 'label' },
  optionValue: { type: String, default: 'value' }
})

// נקבל את כל ה־attrs כדי להעביר ל-Autocomplete
const attrs = useAttrs()

const emit = defineEmits(['update:modelValue'])

// נייצר ערך פנימי שמתאים ל-AutoComplete (אובייקט)
const internalValue = computed({
  get() {
    return props.options.find(o => o[props.optionValue] === props.modelValue) || null
  },
  set(val) {
    emit('update:modelValue', val ? val[props.optionValue] : null)
  }
})

// תוצאות חיפוש
const filtered = ref([])

function search(event) {
  const q = event.query?.toLowerCase() ?? ''
  filtered.value = props.options.filter(o =>
    String(o[props.optionLabel]).toLowerCase().includes(q)
  )
}
</script>

<template>
  <AutoComplete
    v-model="internalValue"
    :suggestions="filtered"
    :optionLabel="optionLabel"
    @complete="search"
    v-bind="attrs"
    force-selection
  >
    <!-- העברת כל הסלוטים -->
    <template v-for="(_, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps" />
    </template>
  </AutoComplete>
</template>
